import React, { useEffect, useRef } from "react";

// Simple scroll reveal wrapper
export const Reveal = ({ children, className = "", delay = 0 }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => el.classList.add("is-visible"), delay);
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.12 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);
  return (
    <div ref={ref} className={`reveal ${className}`}>
      {children}
    </div>
  );
};

export const SectionHeading = ({ eyebrow, title, subtitle, light = false, center = true }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl mb-12`}>
    {eyebrow && (
      <span className="inline-block text-[#84bd00] font-semibold text-sm tracking-widest uppercase mb-3">
        {eyebrow}
      </span>
    )}
    <h2 className={`font-display font-extrabold text-3xl md:text-4xl leading-tight ${light ? "text-white" : "text-[#242424]"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-4 text-lg ${light ? "text-gray-300" : "text-gray-500"}`}>{subtitle}</p>
    )}
  </div>
);

export default Reveal;
